<template>
  <div
    class="screen-adapter"
    v-if="showTip"
    :class="{ 'small-screen': isSmallScreen }"
    @click="handleClick"
  >
    <div class="tip-container">
      <div class="tip-content">
        <img
          v-if="showImg"
          class="warn-icon"
          src="../../../assets/images/finger/screen_warn.png"
          alt="screen warning"
        />
        <p class="tip-text">{{ tipText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScreenAdapter",
  data() {
    return {
      showTip: false,
      tipText: "",
      isApp: false, // 是否在App环境中
      showImg: false,
      isSmallScreen: false,
      isIOS: false,
      lastOrientation: null, // 记录上一次的屏幕方向
      checkTimer: null, // 添加一个timer来实现防抖
    };
  },
  created() {
    // 检测是否在App环境
    this.isApp = this.checkIsApp();
    this.isIOS = this.checkIsIOS();
    if (!this.isApp) {
      this.lastOrientation =
        window.innerWidth > window.innerHeight ? "landscape" : "portrait";
      this.initScreenCheck();
      window.addEventListener("resize", this.checkScreenOrientation);
    }
  },
  destroyed() {
    if (!this.isApp) {
      window.removeEventListener("resize", this.checkScreenOrientation);
    }
  },
  methods: {
    handleClick() {
      this.showTip = false;
    },
    checkIsApp() {
      // 这里需要根据实际情况判断是否在App环境中
      // 例如：return !!window.someAppFlag
      return false;
    },
    initScreenCheck() {
      this.checkScreenOrientation();
    },
    checkIsIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    checkScreenOrientation() {
      // 清除之前的定时器
      if (this.checkTimer) {
        clearTimeout(this.checkTimer);
      }

      // 设置新的定时器
      this.checkTimer = setTimeout(() => {
        const height = window.innerHeight;
        const width = window.innerWidth;
        const currentOrientation = width > height ? "landscape" : "portrait";

        // 检查是否需要刷新页面（仅针对iOS设备从横屏切换到竖屏时）
        console.log("this.isIOS", this.isIOS);
        console.log("this.lastOrientation", this.lastOrientation);
        console.log("currentOrientation", currentOrientation);
        if (
          this.isIOS &&
          this.lastOrientation === "landscape" &&
          currentOrientation === "portrait"
        ) {
          console.log("reload");
          console.log(window.history);
          window.history && window.history.go(0);
          return;
        }

        this.lastOrientation = currentOrientation;

        console.log("height:", height, "width:", width);

        if (width < height) {
          this.tipText = "建议在平板上横屏练习，或使用电脑练习，体验更好哦~";
          this.showTip = true;
          this.showImg = true;
          this.isSmallScreen = false;
        } else if (width > height) {
          this.showTip = false;
          if (height < 400) {
            this.isSmallScreen = true;
            this.tipText = "屏幕有点小哦~为保证练习体验，请在平板或电脑上练习";
            this.showTip = true;
            this.showImg = false;
            setTimeout(() => {
              this.showTip = false;
            }, 2000);
          } else {
            this.isSmallScreen = false;
          }
        } else {
          this.showTip = false;
          this.showImg = false;
          this.isSmallScreen = false;
        }
      }, 500);
    },
  },
};
</script>

<style lang="less" scoped>
.screen-adapter {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  &.small-screen {
    background: transparent; // 小屏幕时移除背景

    .tip-container {
      background: rgba(0, 0, 0, 0.7);
      border: 2px solid rgba(255, 255, 255, 0.2);
      .tip-content {
        .tip-text {
          color: #fff;
          font-size: 24px;
          line-height: 1.5;
          margin-top: 0px;
        }
      }
    }
  }

  .tip-container {
    padding: 15px 25px;
    border-radius: 8px;
    text-align: center;

    .tip-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;

      .warn-icon {
        width: 250px;
        height: 250px;
      }

      .tip-text {
        color: #fff;
        font-size: 32px;
        line-height: 1.5;
        margin-top: 40px;
      }
    }
  }
}
</style>
